export default "__VITE_ASSET__cd07c46f__"